<div class="dialog">
    <div class="header">
        <div class="title-with-count">
            {{data.name}} Wins
            <div class="count">
                <div class="border-none-50"></div>
                {{patient_data.length}}
            </div>
        </div>
    </div>
    <div class="body">
        <div class="patient-table-data">
            <ng-scrollbar class="patient-table">
                <table mat-table [dataSource]="patientDataSource" class="patient-table" matSort>
                    <!-- Number Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="patient-table-header-cell">
                            <div class="header-sort-item">
                                <div class="sort-item-label">A-Z</div>
                                <div class="sort-item-icon">
                                    <svg width="14" height="5" viewBox="0 0 14 5" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.5 5L7 -6.11959e-07L14 0L10.5 5Z" fill="#FF5858" />
                                        <path d="M3.5 0L7 5L0 5L3.5 0Z" fill="#FF5858" />
                                    </svg>
                                </div>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element" class="patient-table-cell bold-font">{{element.firstname
                            + ' ' +element.lastname}}</td>
                    </ng-container>
                    <!-- dob Column -->
                    <ng-container matColumnDef="dob">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="patient-table-header-cell">
                            <div class="header-sort-item">
                                <div class="sort-item-label">A-Z</div>
                                <div class="sort-item-icon">
                                    <svg width="14" height="5" viewBox="0 0 14 5" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.5 5L7 -6.11959e-07L14 0L10.5 5Z" fill="#FF5858" />
                                        <path d="M3.5 0L7 5L0 5L3.5 0Z" fill="#FF5858" />
                                    </svg>
                                </div>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element" class="patient-table-cell">{{element.dob |
                            date:'MM/dd/yyyy'}}</td>
                    </ng-container>
                    <!-- Status Column -->
                    <ng-container matColumnDef="responsible">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="patient-table-header-cell">
                            <div class="header-sort-item">
                                <div class="sort-item-label">A-Z</div>
                                <div class="sort-item-icon">
                                    <svg width="14" height="5" viewBox="0 0 14 5" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.5 5L7 -6.11959e-07L14 0L10.5 5Z" fill="#FF5858" />
                                        <path d="M3.5 0L7 5L0 5L3.5 0Z" fill="#FF5858" />
                                    </svg>
                                </div>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element" class="patient-table-cell">{{element.user}}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"
                        class="patient-table-header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="patient-table-row"></tr>
                </table>
            </ng-scrollbar>
        </div>
    </div>
</div>
